<div id="no-checkins">
  <div class="sp-mt-64 sp-mb-32 t-align-c">
    <i class="fs-64px sp-mr-12" ui-icon uiType="no-checkins"></i>
  </div>
  <h2 class="sp-mb-24 t-align-c color-box text-color-gray-13 fw-600 fs-30px">Check-ins</h2>
  <p class="sp-mb-20 text-color-gray-9 fs-16px fw-400 text">{{ "check_ins_are_currently_disabled_for_this_team" | localize }}</p>
  <p class="sp-mb-20 text-color-gray-9 fs-16px fw-400 text">{{ "checkin_empty_state_text" | localize }}</p>
  <div class="t-align-c" *ngIf="includeCTAButton">
    <button class="sp-px-24 hov-cursor-p text-color-gray-1" (click)="goToManageReflections()" ui-button uiShape="round" uiType="primary" uiSize="large">
      {{ "checkin_empty_state_button" | localize }}
    </button>
  </div>
</div>
